import { render, staticRenderFns } from "./ContactsMap.vue?vue&type=template&id=5ffaecc6&scoped=true&"
import script from "./ContactsMap.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsMap.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ContactsMap.vue?vue&type=style&index=0&id=5ffaecc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffaecc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffaecc6')) {
      api.createRecord('5ffaecc6', component.options)
    } else {
      api.reload('5ffaecc6', component.options)
    }
    module.hot.accept("./ContactsMap.vue?vue&type=template&id=5ffaecc6&scoped=true&", function () {
      api.rerender('5ffaecc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsMap.vue"
export default component.exports